// extracted by mini-css-extract-plugin
export default {"exagon-sync__container":"styles_exagon-sync__container__OiH3r","title":"styles_title__1TNRM","section-title__text":"styles_section-title__text__6qBJ+"};